<template>
  <div class="pdf-viewer-state d-flex flex-column align-items-center justify-content-center">
    <b-spinner v-if="status === 'loading'" variant="primary" class="mb-3"></b-spinner>

    <div
      v-else
      class="pdf-viewer-state__icon rounded-circle d-flex align-items-center justify-content-center mb-3"
    >
      <i class="fas fa-exclamation-triangle"></i>
    </div>

    <h5 class="mb-2 text-center">{{ title }}</h5>
    <p class="mb-0 text-muted text-center">{{ message }}</p>

    <div v-if="status === 'error'" class="mt-4 d-flex align-items-center">
      <b-button variant="primary" class="mr-2" @click="$emit('retry')">Thử lại</b-button>
      <b-button variant="outline-secondary" @click="$emit('close')">Đóng</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfViewerStateBanner',
  props: {
    status: {
      type: String,
      default: 'loading',
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.pdf-viewer-state {
  min-height: 320px;
  padding: 2rem;

  &__icon {
    width: 64px;
    height: 64px;
    background: rgba(220, 53, 69, 0.12);
    color: #dc3545;
    font-size: 1.5rem;
  }
}
</style>
